module.exports = __webpack_public_path__ + "static/ftsblack.2f76b41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ftsblack.png
// module id = 317
// module chunks = 79611799117203